<div class="ostso-dialog landmark">
  <div class="header">
    <h1>{{ isNew ? "Создание целевого ориентира" : "Редактирование целевого ориентира" }}</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <input class="remarktype-textarea"
             [class.error]="form.controls.name.invalid && form.controls.name.touched"
             matInput
             [formControlName]="'name'"
             placeholder="Ориентир"
      >
      <input class="remarktype-textarea"
             [class.error]="form.controls.shortName.invalid && form.controls.shortName.touched"
             matInput
             [formControlName]="'shortName'"
             placeholder="Условное обозначение"
      >

      <mat-form-field appearance="fill"
                      class="pas-select"
                      hideRequiredMarker="true"
                      [class.error]="form.controls.criterion.invalid && form.controls.criterion.touched"
      >
        <mat-label>Критерий</mat-label>
        <mat-select matInput
                    [formControlName]="'criterion'"
        >
          @for (criterion of criterions; track criterion.id) {
            <mat-option [value]="criterion">
              <div [style]="{paddingBlock: '0.5rem'}" >{{ criterion.name }} ({{ criterion.shortName }}), (ID: {{ criterion.id }}),
                ({{ criterion.period.name }})
              </div></mat-option>
          }
        </mat-select>
      </mat-form-field>

      <pas-choise
        title="Тип оценки"
        [items]="periods"
        [formControlName]="'period'"
        [class.error]="form.controls.period.invalid && form.controls.period.touched"
      >
        <ng-template #name let-item>
          {{ item.name }}
        </ng-template>
      </pas-choise>

      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0"
                           [class.error]="form.controls.weight.invalid && form.controls.weight.touched"
                           [style]="{'background-color': '#F3F4F6'}">
        <mat-expansion-panel-header>Вес целевого ориентира</mat-expansion-panel-header>
        <mat-form-field>
          <input matInput [formControlName]="'weight'" type="number" step="0.01" placeholder="Вес целевого ориентира">
        </mat-form-field>
      </mat-expansion-panel>

      <pas-multi-select3 [formControlName]="'indicator'"
                         [class.error]="form.controls.indicator.invalid && form.controls.indicator.touched"
                         title="Показатель"
                         [customDataService]="indicatorService"
                         [options]="{pageSize: 1e6}"
                         customDialogMethod="apiIndicatorGet"
      >
        <ng-template #listItem let-item>
          {{ item.name }} ({{ item.shortName }}), (ID: {{ item.id }}), ({{ item.period.name }})
        </ng-template>
        <ng-template #dialogList let-item>
          {{ item.name }} ({{ item.shortName }}), (ID: {{ item.id }}), ({{ item.period.name }})
        </ng-template>
      </pas-multi-select3>
    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="form.invalid">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

